module.exports = __webpack_public_path__ + "img/userLight.b14c177c.svg";